import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, XMarkIcon } from '@navikt/aksel-icons';
import { Accordion, BodyShort, Button, Detail, Search, Skeleton } from '@navikt/ds-react';
import Dropdown from '../DropDown/Dropdown';
import { EnhetMedUnderenheter } from '../Enheter/EnheterMedUnderenheter';
import { useTastaturNavigasjon } from './useTastaturNavigasjon';
import { formatOrgNr } from './util';
import styles from './Virksomhetsvelger.module.css';
import { VirksomhetsvelgerContext } from './VirksomhetsvelgerContext';
import { VirksomhetsvelgerProvider } from './VirksomhetsvelgerProvider';
import { FocusTrap } from 'focus-trap-react';
const Velger = t0 => {
  const $ = _c(32);
  const {
    friKomponent,
    kunHovedenheter,
    loading
  } = t0;
  const buttonRef = useRef(null);
  const searchRef = useRef(null);
  const valgtEnhetRef = useRef(null);
  const [åpen, setÅpen] = useState(false);
  const {
    søketekst,
    setSøketekst,
    valgtOrganisasjon,
    velgUnderenhet
  } = useContext(VirksomhetsvelgerContext);
  const {
    fokusertEnhet,
    fokuserEnhet,
    organisasjonerMedState,
    handleKeyDown,
    toggleEkspander,
    resetState
  } = useTastaturNavigasjon();
  let t1;
  if ($[0] !== organisasjonerMedState) {
    t1 = organisasjonerMedState.reduce(_temp, 0);
    $[0] = organisasjonerMedState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const antallTreff = t1;
  let t2;
  if ($[2] !== organisasjonerMedState || $[3] !== valgtOrganisasjon) {
    let t3;
    if ($[5] !== valgtOrganisasjon) {
      t3 = o => o.orgnr === valgtOrganisasjon.orgnr || o.underenheter.some(u => u.orgnr === valgtOrganisasjon.orgnr);
      $[5] = valgtOrganisasjon;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = organisasjonerMedState.some(t3);
    $[2] = organisasjonerMedState;
    $[3] = valgtOrganisasjon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const valgtEnhetErIListe = t2;
  const OpenCloseIcon = åpen ? ChevronUpIcon : ChevronDownIcon;
  let t3;
  if ($[7] !== resetState || $[8] !== setSøketekst || $[9] !== åpen) {
    t3 = () => {
      if (åpen) {
        if (document.activeElement !== searchRef.current) {
          valgtEnhetRef.current?.focus();
        }
      } else {
        setSøketekst("");
        resetState();
      }
    };
    $[7] = resetState;
    $[8] = setSøketekst;
    $[9] = åpen;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = fokusertEnhet?.orgnr;
  let t5;
  if ($[11] !== resetState || $[12] !== setSøketekst || $[13] !== t4 || $[14] !== åpen) {
    t5 = [åpen, t4, resetState, setSøketekst];
    $[11] = resetState;
    $[12] = setSøketekst;
    $[13] = t4;
    $[14] = åpen;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t3, t5);
  let t6;
  if ($[16] !== OpenCloseIcon || $[17] !== antallTreff || $[18] !== fokuserEnhet || $[19] !== friKomponent || $[20] !== handleKeyDown || $[21] !== kunHovedenheter || $[22] !== loading || $[23] !== organisasjonerMedState || $[24] !== setSøketekst || $[25] !== søketekst || $[26] !== toggleEkspander || $[27] !== valgtEnhetErIListe || $[28] !== valgtOrganisasjon || $[29] !== velgUnderenhet || $[30] !== åpen) {
    t6 = valgtOrganisasjon && <div className={`${friKomponent ? styles.friKomponent : ""}`}><Button className={styles.virksomhetsvelger} onClick={() => setÅpen(_temp2)} disabled={loading} type="button" variant="secondary" ref={buttonRef} aria-label={`Virksomhetsmeny. Valgt virksomhet er ${valgtOrganisasjon.navn} med virksomhetsnummer ${valgtOrganisasjon.orgnr}`} aria-haspopup="dialog" aria-controls={åpen ? "VirksomhetsvelgerPopup" : undefined} aria-expanded={åpen}><div className={styles.innhold}><div className={styles.tekst}>{loading ? <Skeleton style={{
              backgroundColor: "var(--ax-bg-info-strong)"
            }} /> : <BodyShort className={styles.virksomhetsnavn}>{valgtOrganisasjon.navn}</BodyShort>}{loading ? <Skeleton style={{
              backgroundColor: "var(--ax-bg-info-strong)"
            }} /> : <BodyShort>{`Org.nr. ${formatOrgNr(valgtOrganisasjon.orgnr)}`}</BodyShort>}</div><OpenCloseIcon style={{
            pointerEvents: "none"
          }} aria-hidden={true} /></div></Button><Dropdown id="VirksomhetsvelgerPopup" ariaLabel="Virksomhetsvelger" friKomponent={true} erApen={åpen}><FocusTrap focusTrapOptions={{
          clickOutsideDeactivates: e => {
            if (buttonRef.current && e.target instanceof Node && buttonRef.current.contains(e.target)) {} else {
              setÅpen(false);
            }
            return true;
          },
          escapeDeactivates: () => {
            setÅpen(false);
            return true;
          }
        }}><div className={styles.popup}><div className={styles.popupHeader}><Search ref={searchRef} variant="simple" value={søketekst} onChange={setSøketekst} clearButtonLabel={"T\xF8m s\xF8kefelt"} placeholder={"S\xF8k p\xE5 virksomhet ..."} label={"S\xF8k p\xE5 virksomhet"} autoComplete="organization" /><Button variant="tertiary" aria-label="lukk virksomhetsvelger" size="small" onClick={() => setÅpen(false)}><XMarkIcon aria-hidden={true} /></Button></div><Detail role="status">{søketekst.length > 0 && <>{antallTreff === 0 ? `Ingen treff på "${søketekst}"` : `${antallTreff} treff på "${søketekst}".`}</>}</Detail><Accordion style={{
              display: "flex"
            }}><div className={styles.enheter} onKeyDown={handleKeyDown}>{organisasjonerMedState.map((org_0, i) => <EnhetMedUnderenheter tvingTabbable={!valgtEnhetErIListe && i === 0} key={org_0.orgnr} enhetRef={valgtEnhetRef} organisasjon={org_0} kunHovedenheter={kunHovedenheter} onUnderenhetValgt={org_1 => {
                  setÅpen(false);
                  velgUnderenhet(org_1);
                }} onHovedenhetClick={toggleEkspander} onFocus={org_2 => {
                  fokuserEnhet(org_2);
                }} />)}</div></Accordion></div></FocusTrap></Dropdown></div>;
    $[16] = OpenCloseIcon;
    $[17] = antallTreff;
    $[18] = fokuserEnhet;
    $[19] = friKomponent;
    $[20] = handleKeyDown;
    $[21] = kunHovedenheter;
    $[22] = loading;
    $[23] = organisasjonerMedState;
    $[24] = setSøketekst;
    $[25] = søketekst;
    $[26] = toggleEkspander;
    $[27] = valgtEnhetErIListe;
    $[28] = valgtOrganisasjon;
    $[29] = velgUnderenhet;
    $[30] = åpen;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};
export interface Organisasjon {
  orgnr: string;
  navn: string;
  underenheter: Organisasjon[];
}
export const Virksomhetsvelger = t0 => {
  const $ = _c(7);
  const {
    organisasjoner,
    onChange,
    initValgtOrgnr,
    friKomponent,
    kunHovedenheter,
    loading: t1
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== friKomponent || $[1] !== initValgtOrgnr || $[2] !== kunHovedenheter || $[3] !== loading || $[4] !== onChange || $[5] !== organisasjoner) {
    t2 = !loading ? <VirksomhetsvelgerProvider organisasjonstre={organisasjoner} onOrganisasjonChange={onChange} initValgtOrgnr={initValgtOrgnr} kunHovedenheter={kunHovedenheter}><Velger friKomponent={friKomponent} kunHovedenheter={kunHovedenheter} loading={false} /></VirksomhetsvelgerProvider> : <Velger friKomponent={friKomponent} kunHovedenheter={kunHovedenheter} loading={loading} />;
    $[0] = friKomponent;
    $[1] = initValgtOrgnr;
    $[2] = kunHovedenheter;
    $[3] = loading;
    $[4] = onChange;
    $[5] = organisasjoner;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(acc, org) {
  return acc + (org.underenheter.length || 1);
}
function _temp2(prev) {
  return !prev;
}